import type { Resource } from '@/types/resource.type';
import { Theme } from '@/types/theme.type';

export const LOCAL_STORAGE = {
  navigationClosed: {
    key: 'navigation-closed',
    initialValue: true,
  },
  theme: {
    key: 'theme',
    initialValue: Theme.AUTO,
  },
  dismissedEditRequestNotifications: (campaignRequestId: number) => ({
    key: `dismissed-edit-request-notifications-${campaignRequestId}`,
    initialValue: [] as number[],
  }),
  dismissedCampaignRequestNotifications: (campaignRequestId: number) => ({
    key: `dismissed-campaign-request-notifications-${campaignRequestId}`,
    initialValue: [] as number[],
  }),
  columnsConfig: (resource: Resource) => ({
    key: `table-columns-${resource}`,
    initialValue: [],
  }),
  searchHistory: (resource: Resource) => ({
    key: `search-history-${resource}`,
    initialValue: [] as string[],
  }),
};

export const SESSION_STORAGE = {
  timezonePromptDismissed: { key: 'tz-prompt-dismissed' },
  campaignRequestCreateDraft: { key: 'campaign-create-draft' },
  campaignRequestProgramCreateDraft: { key: 'campaign-request-program-create-draft' },
  campaignRequestProgramEditDraft: (id: number) => ({ key: `campaign-request-program-edit-draft-${id}` }),
  campaignRequestDuplicateDraft: (id: string) => ({ key: `campaign-duplicate-draft-${id}` }),
  campaignRequestEdit: (id: string) => ({ key: `campaign-edit-${id}` }),
  campaignRequestEditDraft: (id: string) => ({ key: `campaign-edit-draft-${id}` }),
  campaignRequestDuplicate: (id: string) => ({ key: `campaign-duplicate-${id}` }),
  campaignEditRequest: (id: string) => ({ key: `campaign-edit-request-${id}` }),
  campaignEditRequestNewRecord: (campaignId: string) => ({ key: `campaign-edit-request-new-record-${campaignId}` }),
  payoutExpandedIds: { key: 'payout-expanded-ids' },
  payoutGroupIds: { key: 'payout-group-ids' },
  shouldNotifySignIn: { key: 'should-notify-sign-in' },
  campaignRequestChatOpen: (campaignRequestId: number) => ({ key: `campaign-request-chat-open-${campaignRequestId}` }),
  campaignRequestChatScrollTop: (campaignRequestId: number) => ({ key: `campaign-request-chat-scroll-top-${campaignRequestId}` }),
};
